import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTheme, styled } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Drawer from "@mui/material/Drawer";
import Grid from "@mui/material/Grid";
import { NavToolBar } from "./NavToolBar";
import { DrawerFooter } from "./DrawerFooter";

// import LifeSaferLogo from "@/_images/logos/LogoLimited.png";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import HistoryIcon from "@mui/icons-material/History";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import customerSupport from "../../_images/Customer_Support.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import { LanguageSelector } from "../LanguageSelector";
import { useLocation } from "react-router-dom";

const drawerWidth = 300;

const Logo = styled("img")(({ theme, isISA }) => ({
  marginTop: isISA ? 0 : 8,
  marginBottom: isISA ? 0 : 8,
  [theme.breakpoints.up("sm")]: {
    width: 190,
    height: isISA ? "auto" : 40,
  },
  [theme.breakpoints.down("sm")]: {
    width: 138,
    height: isISA ? "auto" : 28,
  },
}));

const CreditBox = styled(Grid)(() => ({
  minHeight: "160px",
  maxHeight: "160px",
}));

// const CustomAppBar = styled(AppBar)((theme) => ({
//     [theme.breakpoints.up("md")]: {
//       width: `calc(100%-${drawerWidth}px)`,
//       marginLeft: drawerWidth,
//     },
// }));

const CustomAppBar = styled(AppBar)(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    // width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
}));

const CustomDrawer = styled("nav")(({ theme }) => ({
  [theme.breakpoints.up("sm")]: {
    width: drawerWidth,
    flexShrink: 0,
  },
}));

function Nav({
  unreadNotifications,
  selectedNav,
  updateSelected,
  window: windowProp,
  referralSiteData,
  phoneNumber,
  resolvedUrl,
  siteLogo,
  isISA,
}) {
  const theme = useTheme();
  const { t } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [partnerStoryUiStep, setPartnerStoryUiStep] = useState(() => {
    const currentStep = Number(sessionStorage.getItem("partnerStoryUiStep"));
    return Number.isFinite(currentStep) ? currentStep : 0;
  });
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isPartnerInlineLangBreakpoint = useMediaQuery("(min-width:900px)");
  const location = useLocation();

// will be used later
  // useEffect(() => {
  //   const syncPartnerStep = () => {
  //     const currentStep = Number(sessionStorage.getItem("partnerStoryUiStep"));
  //     setPartnerStoryUiStep(Number.isFinite(currentStep) ? currentStep : 0);
  //   };

  //   window.addEventListener("focus", syncPartnerStep);

  //   return () => {
  //     window.removeEventListener("focus", syncPartnerStep);
  //   };
  // }, []);

useEffect(() => {
  const syncPartnerStep = () => {
    const currentStep = Number(
      sessionStorage.getItem("partnerStoryUiStep")
    );

    setPartnerStoryUiStep(
      Number.isFinite(currentStep) ? currentStep : 0
    );
  };

  window.addEventListener("partnerStepUpdated", syncPartnerStep);

  return () => {
    window.removeEventListener(
      "partnerStepUpdated",
      syncPartnerStep
    );
  };
}, []);


  const isPartnerFirstStep =
    location?.pathname?.toLowerCase()?.startsWith("/story/partner") &&
    partnerStoryUiStep === 0;
  const shouldHideNavLanguageSelector =
    isPartnerFirstStep && isPartnerInlineLangBreakpoint;

  const updateSelectedNav = (index) => {
    updateSelected(index);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Grid
      container
      // direction="column"
      sx={{
        flexGrow: 1,
        minHeight: 420,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Grid sx={{ textAlign: "center", pt: 1, width: "100%" }}>
        <CloseIcon
          onClick={() => setMobileOpen(!mobileOpen)}
          sx={{
            color: "#76bc21",
            position: "absolute",
            left: 20,
            top: 15,
            fontSize: 28,
            display: { xs: "block", sm: "none" },
            cursor: "pointer",
            marginTop: isISA ? "15px" : "0px",
          }}
        />
        <Link
          href={
            isISA || resolvedUrl === "lifesaferisa.com"
              ? "https://www.lifesaferisa.com"
              : "https://www.lifesafer.com"
          }
        >
          <Logo
            src={siteLogo}
            isISA={isISA ?? enrolleeUser?.deviceType?.toLowerCase() === "speed"}
            alt="LifeSafer"
          />
        </Link>
      </Grid>

      <Grid sx={{ display: { xs: "block", sm: "none" }, width: "100%" }}>
        <Divider sx={{ backgroundColor: "#000" }} />
        <Grid
          container
          my={2}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Link
            underline="none"
            href={
              isISA || resolvedUrl === "lifesaferisa.com"
                ? "https://www.lifesaferisa.com"
                : "https://www.lifesafer.com"
            }
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "25px",
              px: "20px",
              width: "100%",
            }}
          >
            <HistoryIcon sx={{ color: "#1c355e" }} />
            <Typography
              sx={{ fontWeight: 900, color: "#1c355e", textAlign: "left" }}
            >
              {t("navigation.returnTo")} <br />
              {isISA || resolvedUrl === "lifesaferisa.com"
                ? t("navigation.lifesaferisa")
                : t("navigation.lifesafer")}
            </Typography>
          </Link>
        </Grid>
        <Divider sx={{ backgroundColor: "#000" }} />
      </Grid>

      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <img
          src={customerSupport}
          style={{ height: 220, width: 220, zIndex: 5 }}
        />
      </Grid>

      <Grid
        container
        sx={{
          justifyContent: "center",
          px: 2,
          width: "100%",
          flex: "1 1 auto",
          position: "relative",
          bottom: 30,
        }}
      >
        <CreditBox
          sx={{
            padding: 2,
            marginTop: 2,
            border: "1px solid #1c355e",
            borderRadius: 1,
            backgroundColor: "aliceblue",
            boxSizing: "border-box",
            width: "100%",
          }}
        >
          <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ width: "100%" }}
          >
            <Typography sx={{ textAlign: "center", fontWeight: 500 }}>
              {t("navigation.assistMessage")}
            </Typography>
            <Button
              size="small"
              variant="contained"
              startIcon={<PhoneIphoneIcon />}
              sx={{
                height: 35,
                mt: 2,
                mb: 2,
                px: 2,
                width: "max-content",
              }}
              component="a"
              href={`tel:${phoneNumber}`}
            >
              {phoneNumber}
            </Button>
          </Grid>
        </CreditBox>
      </Grid>

      {/* Footer */}
      <Grid sx={{ width: "100%" }}>
        <DrawerFooter   isISA={isISA} />
      </Grid>
    </Grid>
  );

  const container =
    windowProp !== undefined ? () => windowProp().document.body : undefined;
  const invisible = true;

  return (
    <div>
      <CustomAppBar
        position="fixed"
        elevation={2}
        sx={{ backgroundColor: "white", paddingRight: "0px !important" }}
      >
        {isMobileOrTablet ? (
          <NavToolBar
            selectedNav={selectedNav}
            unreadNotifications={unreadNotifications}
            invisible={invisible}
            handleDrawerToggle={handleDrawerToggle}
            setMobileOpen={setMobileOpen}
            updateSelectedNav={updateSelectedNav}
            referralSiteData={referralSiteData}
            phoneNumber={phoneNumber}
            siteLogo={siteLogo}
            isISA={isISA}
          />
        ) : (
          <Grid
            sx={{ height: "0px", paddingRight: "24px" }}
            container
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
          >
            {!shouldHideNavLanguageSelector ? (
              <Grid mt={1}>
                <LanguageSelector />
              </Grid>
            ) : null}
          </Grid>
        )}
      </CustomAppBar>

      <CustomDrawer aria-label="drawer navigation">
        <Drawer
          container={container}
          variant="temporary"
          anchor={theme.direction === "rtl" ? "right" : "left"}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </CustomDrawer>
    </div>
  );
}

Nav.propTypes = {
  unreadNotifications: PropTypes.number.isRequired,
  selectedNav: PropTypes.string,
  updateSelected: PropTypes.func.isRequired,
  window: PropTypes.object,
  referralSiteData: PropTypes.string,
  phoneNumber: PropTypes.string,
  resolvedUrl: PropTypes.string,
  siteLogo: PropTypes.string,
  isISA: PropTypes.bool,
};

export { Nav };
